export default __webpack_public_path__ + "static/media/a.4d090bc1.svg";